const ARCHIVE_CAMPAIGN_START = "2023-02-22T08:43:10.987Z";
const MARKETPLACE_CAMPAIGN_START = "2023-04-25T08:43:10.987Z";
const TICKET_NAVIGATION_CAMPAIGN_START = "2023-05-25T08:43:10.987Z";
const AUTOMATIONS_CAMPAIGN_START = "2023-08-30T08:43:10.987Z";
const RICH_TEXT_IN_CANNED_RESPONSES_CAMPAIGN_START = "2023-11-06T11:22:34.390Z";
const MACROS_CAMPAIGN_START = "2024-03-25T12:00:00.000Z";
const AUTOASSIGNMENT_CAMPAIGN_START = "2024-07-17T08:00:00.000Z";
const LANGUAGE_DETECTION_CAMPAIGN_START = "2024-09-18T07:30:00.000Z";
const CONTACT_FORMS_CAMPAIGN_START = "2024-09-23T12:00:00.000Z";
const SORTING_CAMPAIGN_START = "2024-10-28T12:00:00.000Z";
const COLLAPSE_MESSAGE_BOX_CAMPAIGN_START = "2024-11-22T09:00:00.000Z";
const UNDELIVERED_CAMPAIGN_START = "2025-02-05T09:00:00.000Z";
const DARK_MODE_CAMPAIGN_START = "2024-11-28T09:00:00.000Z";
const AGENT_AUTOASSIGNMENT_MANAGEMENT_CAMPAIGN_START = "2025-02-10T08:00:00.000Z";
export const CONTEXT_2025_PROMO_CAMPAIGN_START = "2025-09-15T00:00:00.000Z";
export const CONTEXT_2025_PROMO_CAMPAIGN_END = "2025-09-24T23:59:59.000Z";

type CampaignKeys =
  | "hasSeenMarketplace"
  | "hasSeenNoResultsInSiloTooltip"
  | "hasSeenSiloTooltip"
  | "hasSeenArchiveOnboardingBanner"
  | "hasSeenNavigationInTicketTooltip"
  | "hasSeenAutomationsSection"
  | "hasSeenRichTextInCannedResponses"
  | "hasClosedMacrosTooltip"
  | "hasOpenedAutomationsAfterMacrosRelease"
  | "hasSeenMacrosSection"
  | "hasClosedMacrosBanner"
  | "hasClosedWorkflowsBanner"
  | "hasClosedAutoAssignmentPromo"
  | "hasClosedLanguageDetectionPromo"
  | "hasSeenLanguageCondition"
  | "hasClosedContactFormsBanner"
  | "hasSeenSortingTooltip"
  | "hasSeenCollapseMessageBoxButton"
  | "hasClosedUndeliveredViewBanner"
  | "hasEnteredUndeliveredTickets"
  | "hasSeenDarkModePromoTooltip"
  | "hasClosedProfileMenuAutoAssignmentTooltip"
  | "hasSeenAutoAssignmentSwitcherInProfileMenu";

interface ICampaign {
  flag: string;
  campaignStartDate: string;
}

export const newFeaturesCampaigns: Record<CampaignKeys, ICampaign> = {
  hasSeenMarketplace: {
    flag: "hasSeenMarketplace_cfe3717730d3509acc78fc6fea579f51",
    campaignStartDate: MARKETPLACE_CAMPAIGN_START,
  },
  hasSeenNoResultsInSiloTooltip: {
    flag: "hasSeenNoResultsInSiloTooltip_40cd6cdbe09203b2562bce2c5444ea06",
    campaignStartDate: ARCHIVE_CAMPAIGN_START,
  },
  hasSeenSiloTooltip: {
    flag: "hasSeenSiloTooltip_6fa92777262ab9d30e7fe8648662b02b",
    campaignStartDate: ARCHIVE_CAMPAIGN_START,
  },
  hasSeenArchiveOnboardingBanner: {
    flag: "hasSeenArchiveOnboardingBanner_f5985d4b03542e858a492f2b836b0bf7",
    campaignStartDate: ARCHIVE_CAMPAIGN_START,
  },
  hasSeenNavigationInTicketTooltip: {
    flag: "hasSeenNavigationInTicketTooltip_c38a94dd80116a54bf68d48544c51ebd",
    campaignStartDate: TICKET_NAVIGATION_CAMPAIGN_START,
  },
  hasSeenAutomationsSection: {
    flag: "hasSeenAutomationsSection_97d6ddc88f2e02d4425372c442dcc0d3",
    campaignStartDate: AUTOMATIONS_CAMPAIGN_START,
  },
  hasSeenRichTextInCannedResponses: {
    flag: "hasSeenRichTextInCannedResponses_b72d44b6162cfe0e9045d3676ecb28ea",
    campaignStartDate: RICH_TEXT_IN_CANNED_RESPONSES_CAMPAIGN_START,
  },
  hasClosedMacrosTooltip: {
    flag: "hasClosedMacrosTooltip_e0dad333b8956c341e65d54719ff8755",
    campaignStartDate: MACROS_CAMPAIGN_START,
  },
  hasOpenedAutomationsAfterMacrosRelease: {
    flag: "hasOpenedAutomationsAfterMacrosRelease_225a12730cbc6663a79bd2f7a5209310",
    campaignStartDate: MACROS_CAMPAIGN_START,
  },
  hasSeenMacrosSection: {
    flag: "hasSeenMacrosSection_f3647bcee21acd756866fe0609869a1c",
    campaignStartDate: MACROS_CAMPAIGN_START,
  },
  hasClosedMacrosBanner: {
    flag: "hasClosedMacrosBanner_e51bb101635f96f74111c7d80afaba1d",
    campaignStartDate: MACROS_CAMPAIGN_START,
  },
  hasClosedWorkflowsBanner: {
    flag: "hasClosedWorkflowsBanner_886b78b80774b5b76175eb939e88233f",
    campaignStartDate: MACROS_CAMPAIGN_START,
  },
  hasClosedContactFormsBanner: {
    flag: "hasClosedContactFormsBanner_09be3d111b4bf0d32e8aaebdbd309e4d",
    campaignStartDate: CONTACT_FORMS_CAMPAIGN_START,
  },
  hasClosedAutoAssignmentPromo: {
    flag: "hasClosedAutoAssignmentPromo_cbc1f556714dda275b5d710ae09ac555",
    campaignStartDate: AUTOASSIGNMENT_CAMPAIGN_START,
  },
  hasClosedLanguageDetectionPromo: {
    flag: "hasClosedLanguageDetectionPromo_0e7bfd5466b8b7d2ea9e5eb0fefc67f0",
    campaignStartDate: LANGUAGE_DETECTION_CAMPAIGN_START,
  },
  hasSeenLanguageCondition: {
    flag: "hasSeenLanguageCondition_ad9ced161ad91994be479af5fd0a187a",
    campaignStartDate: LANGUAGE_DETECTION_CAMPAIGN_START,
  },
  hasSeenSortingTooltip: {
    flag: "hasSeenSortingTooltip_e54f6926b78523a9b1439cccc518a44b",
    campaignStartDate: SORTING_CAMPAIGN_START,
  },
  hasSeenCollapseMessageBoxButton: {
    flag: "hasSeenCollapseMessageBoxButton_22ae700dfac84ef03284abb643f18004",
    campaignStartDate: COLLAPSE_MESSAGE_BOX_CAMPAIGN_START,
  },
  hasClosedUndeliveredViewBanner: {
    flag: "hasClosedUndeliveredViewBanner_b74edbc34e133a8043865d3202ff33de",
    campaignStartDate: UNDELIVERED_CAMPAIGN_START,
  },
  hasEnteredUndeliveredTickets: {
    flag: "hasEnteredUndeliveredTickets_1d7f48d24b5278ec78c50c575274acda",
    campaignStartDate: UNDELIVERED_CAMPAIGN_START,
  },
  hasSeenDarkModePromoTooltip: {
    flag: "hasSeenDarkModePromoTooltip_961635b75c2129e768646498de92c416",
    campaignStartDate: DARK_MODE_CAMPAIGN_START,
  },
  hasClosedProfileMenuAutoAssignmentTooltip: {
    flag: "hasClosedProfileMenuAutoAssignmentTooltip_c939b9ca4f768521439813af6534b2fe",
    campaignStartDate: AGENT_AUTOASSIGNMENT_MANAGEMENT_CAMPAIGN_START,
  },
  hasSeenAutoAssignmentSwitcherInProfileMenu: {
    flag: "hasSeenAutoAssignmentSwitcherInProfileMenu_0179dafa8620ef3eedbb30ef5317073f",
    campaignStartDate: AGENT_AUTOASSIGNMENT_MANAGEMENT_CAMPAIGN_START,
  },
};
